import React, { useEffect, useRef, useId } from 'react';
import { Check, Minus } from 'lucide-react';
export interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  helperText?: string;
  disabled?: boolean;
  error?: boolean;
  indeterminate?: boolean;
  className?: string;
  'data-id'?: string;
}
export const Checkbox: React.FC<CheckboxProps> = ({
  checked = false,
  onChange,
  label,
  helperText,
  disabled = false,
  error = false,
  indeterminate = false,
  className = '',
  'data-id': dataId
}) => {
  const id = useId();
  const inputRef = useRef<HTMLInputElement>(null);
  // Handle indeterminate state
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);
  const handleChange = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      handleChange();
    }
  };
  return <div className={`inline-flex flex-col ${className}`} data-id="element-890" data-mp="rrxnwad166ct">
      <div className="flex items-start gap-[10px]" data-id="element-891" data-mp="mtdzm3aysiha">
        {/* Checkbox Input */}
        <div className="relative flex-shrink-0 mt-[2px]" data-id="element-892" data-mp="irsg3z3xd5y4">
          <input ref={inputRef} type="checkbox" id={id} checked={checked} onChange={handleChange} disabled={disabled} aria-checked={indeterminate ? 'mixed' : checked} aria-disabled={disabled} aria-invalid={error} className="sr-only" data-id="element-893" data-mp="iq7mqctcjt1u" />

          <label htmlFor={id} className={`
              flex items-center justify-center
              w-[18px] h-[18px]
              border-2 rounded
              transition-all duration-200
              cursor-pointer
              ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:border-[#0EA5E9]'}
              ${error ? 'border-[#EF4444]' : checked || indeterminate ? 'border-[#0EA5E9] bg-[#0EA5E9]' : 'border-[#CBD5E1] bg-white'}
              ${!disabled && 'focus-within:ring-[3px] focus-within:ring-[rgba(14,165,233,0.2)]'}
            `} onKeyDown={handleKeyDown} tabIndex={disabled ? -1 : 0} data-id="element-894" data-mp="43eflutzdtkq">

            {indeterminate ? <Minus className="w-[14px] h-[14px] text-white" strokeWidth={3} data-id="element-895" data-mp="3cm6lg9l21y28" /> : checked ? <Check className="w-[14px] h-[14px] text-white" strokeWidth={3} data-id="element-896" data-mp="2xoe7vmz2jjqo" /> : null}
          </label>
        </div>

        {/* Label and Helper Text */}
        {(label || helperText) && <div className="flex flex-col gap-1" data-id="element-897" data-mp="3qcjyurgpu4yy">
            {label && <label htmlFor={id} className={`
                  text-[14px] leading-normal cursor-pointer
                  ${error ? 'text-[#EF4444]' : 'text-[#0F172A]'}
                  ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
                `} data-id="element-898" data-mp="3qd1xtvurixak">

                {label}
              </label>}
            {helperText && <span className={`
                  text-[13px] leading-normal
                  ${error ? 'text-[#EF4444]' : 'text-[#94A3B8]'}
                  ${disabled ? 'opacity-50' : ''}
                `} data-id="element-899" data-mp="3ljgzu3t663bd">

                {helperText}
              </span>}
          </div>}
      </div>
    </div>;
};